import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  List,
  ListItem,
  InputAdornment,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IoMdSettings } from "react-icons/io";
import { AiFillShopping } from "react-icons/ai";
import { MdEdit } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import SearchIcon from "@mui/icons-material/Search";
import { useLanguageContext } from "../../Context/LanguageContext";
import commonUtils from "../../helpers/commonUtils";
import { makeStyles } from "@mui/styles";
import { Padding } from "@mui/icons-material";
import { SettingSideBarItems } from "./HelperUtil";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: "12px",
    fontWeight: "600",
  },
}));
export default function SettingContent({
  contentSettingAccordion,
  setContentSettingAccordion,
}) {
  const classes = useStyles();
  const location = useLocation();
  const { localization } = useLanguageContext();
  const configItem = SettingSideBarItems(localization, commonUtils);

  const [expanded, setExpanded] = useState(contentSettingAccordion); // Open the first accordion initially
  const [searchQuery, setSearchQuery] = useState("");

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredConfigItem = configItem.map((group, groupIndex) => {
    const filteredItems = group.items.filter(
      (item) =>
        item.show &&
        item.lable.toLowerCase().includes(searchQuery.toLowerCase()),
    );
    return {
      ...group,
      items: filteredItems,
      isVisible: filteredItems.length > 0,
    };
  });

  useEffect(() => {
    const firstVisibleIndex = filteredConfigItem.findIndex(
      (group) => group.isVisible,
    );
    // a
  }, [searchQuery]);

  useEffect(() => {
    const path = location.pathname;
    const expandedIndex = configItem.findIndex((group) =>
      group.items.some((item) => item.path.includes(path)),
    );
    if (expandedIndex !== -1) {
      setExpanded(expandedIndex);
      setContentSettingAccordion(expandedIndex);
    } else {
      setExpanded(0);
      setContentSettingAccordion(0);
    }
  }, [location.pathname]);

  const hasVisibleItems = filteredConfigItem.some((group) => group.isVisible);

  const returnAccordionClass = (_keyId) => {
    if (_keyId === "Organization") {
      return "OrganizationAccordion";
    } else if (_keyId === "Inspection") {
      return "InspectionAccordion";
    } else if (_keyId === "Equipment") {
      return "EquipmentAccordion";
    } else if (_keyId === "General") {
      return "GeneralAccordion";
    }
  };
  return (
    <nav id="sideBarContentContainer">
      <Typography className="sideBarHeader">{localization.settings}</Typography>
      <TextField
        className="sideBarSearchCls"
        placeholder={localization.search}
        variant="outlined"
        fullWidth
        margin="normal"
        onChange={handleSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon className="searchIconCls" />
            </InputAdornment>
          ),
        }}
      />
      <div className="sidebarAccordion">
        {hasVisibleItems ? (
          filteredConfigItem.map((group, index) =>
            group.isVisible ? (
              <Accordion
                className={returnAccordionClass(group.key)}
                key={index}
                expanded={expanded === index}
                onChange={handleAccordionChange(index)}
              >
                <AccordionSummary
                  className={group.key}
                  expandIcon={<ExpandMoreIcon />}
                >
                  <Typography
                    className={classes.heading}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    {group.icon && (
                      <span style={{ marginRight: 8 }}>{group.icon}</span>
                    )}
                    {group.category}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <List>
                    {group.items.map((item, subIndex) => (
                      <ListItem key={subIndex} button>
                        <NavLink
                          className={({ isActive }) =>
                            isActive
                              ? "nav-link pl-0 active-link"
                              : "nav-link pl-0"
                          }
                          style={{
                            padding: "none",
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                          onClick={() => {
                            setContentSettingAccordion(expanded);
                          }}
                          to={item.path}
                        >
                          {item.lable}
                        </NavLink>
                      </ListItem>
                    ))}
                  </List>
                </AccordionDetails>
              </Accordion>
            ) : null,
          )
        ) : (
          <Typography variant="body2" color="textSecondary">
            {localization.nomatchfound}
          </Typography>
        )}
      </div>
    </nav>
  );
}
